<template>
  <div id="ggu">
    <!-- <div class="banner">
      <div class="top">
        <img src="@/assets/img/logo.png" alt="">
      </div>
      <div class="bottom">
        <p class="title">预约一对一免费咨询</p>
        <p class="content">该信息仅用于世毕盟艺术与设计留学为您提供一对一咨询服务，不做其他用途。</p>
      </div>
    </div> -->
    <form class="form">
      <p class="title"><span>在线预约免费咨询</span></p>
      <div>
        <input type="text" placeholder="姓名(必填)" v-model='form.name' required @focus="isClear"/>
        <p class="tips" v-if="isName">姓名不能为空！</p>
      </div>
      <div>
        <input type="text" placeholder="手机号(必填)" v-model='form.phone' required  @focus="isClear"/>
        <p class="tips" v-if="isPhone">手机号不能为空！</p>
        <p class="tips" v-if="isPhone_">手机号格式不正确! </p>
      </div>
      <div>
        <input type="text" placeholder="毕业/所在院校(必填)" v-model='form.school' required  @focus="isClear"/>
        <p class="tips" v-if="iswx_phone">毕业/所在院校不能为空！</p>
      </div>
      <div>
        <input type="text" placeholder="学习专业和年级(必填)" v-model='form.major' required @focus="isClear"/>
        <p class="tips" v-if="isSchool">学习专业和年级不能为空！</p>
      </div>
      <div>
        <input type="text" placeholder="微信号(必填)" v-model='form.wx_phone' required @focus="isClear"/>
        <p class="tips" v-if="isMajor">微信号不能为空！</p>
      </div>
      <p class="button" @click="submit">提交</p>
    </form>
    <!-- 遮罩 -->
    <van-overlay :show="isShow" default @click="isShow = false">
      <div class="wrapper" @click.stop>
        <div class="mask">
          <p>预约成功!</p>
          <p>我们的工作人员将尽快与您联系</p>
          <span class="iconfont icon-guanbi" @click="isShow = false"></span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
const imgUrl = "http://www.gguconsulting.com/Public/img/";
import api from "@/api/subscribe";
export default {
  data() {
    return {
      imgUrl,
      isShow:false,
      isName:false,
      isPhone:false,
      isPhone_:false,
      iswx_phone:false,
      isSchool:false,
      isMajor:false,
      form:{
        name:"",
        phone:"",
        wx_phone:"",
        school:"",
        major:""
      }
    };
  },
  methods: {
    isClear(){
      this.isName=false;
      this.isPhone=false;
      this.isPhone_=false;
      this.iswx_phone=false;
      this.isSchool=false;
      this.isMajor=false;
    },
      // 表单提交
    submit () {
      if(!this.form.name){ 
          this.isName = true;
          return
        };
      if(!this.form.phone){ 
          this.isPhone = true;
          return
        }else{
        if (/^1[3456789](\d){9}$/.test(this.form.phone)) {
          
        } else {
          this.isPhone_ = true;
          return;
        }
      };
      if(!this.form.school) { 
          this.iswx_phone = true;
          return
        };
      if(!this.form.major) { 
          this.isSchool = true;
          return
        };
      if(!this.form.wx_phone) { 
          this.isMajor = true;
          return
        };
      let obj = {
          name: this.form.name,
          phone: this.form.phone,
          wx_phone: this.form.wx_phone,
          school: this.form.school,
          major: this.form.major,
          type:'1'
      }
      this.reqSubmitFeedback(obj)

    },
    //预约咨询
    async reqSubmitFeedback(data) {
      try {
        let re = await api.wx_make_add(data);
        if(re.data.rt == 1){
          // this.$notify('预约成功！');
          this.isShow = true;
          this.form={
            name:"",
            phone:"",
            wx_phone:"",
            school:"",
            major:""
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    
    }
};
</script>

<style lang="less" scoped>
// #ggu{
//     height:100%;
//     background:#2a62d1;
// }
.banner{
  width:100%;
  height:455px;
//   background:url("../../assets/img/banner.png") no-repeat;
background:#777;
  background-size:100% 100%;
  .top{
    padding:28px 0 0 33px;
    img{
      width:202px;
      height:auto;
    }
  }
  .bottom{
    margin-top:45px;
    padding:0 185px 0 70px;
    font-family: 'PingFang Regular';
    color:#fff;
    font-size:24px;
    line-height:40px;
    .title{
      font-size:40px;
      font-weight:600;
      margin-bottom:30px;
    }
  }
}
.form{
  background:#fff;
  width:100%;
  border-radius:50px 50px 0px 0px;
//   margin-top:-50px;
  padding:100px 85px 45px;
  box-sizing:border-box;
  .title{
    font-size:34px;
    text-align: center;
    color:#000;
    font-family: 'PingFang Regular';
    margin-bottom:100px;
    span{
      display:inline-block;
      padding-bottom:13px;
      border-bottom:5px solid #000;
    }
  }
  div{
    margin-bottom:40px;
    position: relative;
    .tips{
      position: absolute;
      bottom:-35px;
      left: 0;
      color:#f00;
    }
  }
  input{
    display:block;
    width:100%;
    height:74px;
    background:rgba(247,248,250,1);
    border-radius:10px;
    line-height:74px;
    padding:0 45px;
    box-sizing:border-box;
    border:none;
    outline:none;
    font-size:30px;
    font-family: 'PingFang Regular';
    border:1px solid rgba(247,248,250,1)
  }
  .button{
    display:block;
    width:580px;
    height:84px;
    line-height:84px;
    text-align:center;
    background:#2a62d1;
    border-radius:42px;
    border:none;
    outline:none;
    font-family: 'PingFang Regular';
    font-size:32px;
    color:#fff;
    margin:130px auto 0;
  }
}
// 遮罩
.van-overlay {
  z-index: 2000 !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .mask {
    width: 600px;
    border-radius: 20px;
    padding: 80px 0px 80px;
    background: #fff;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    margin-bottom: 100px;
    font-family: 'PingFang Regular';
    background:#f7faff;
    img {
      width: 350px;
      height: 350px;
      margin-top:20px;
    }
    p {
      font-size: 30px;
      color: #2d2d2d;
      font-weight: bold;
      margin-bottom:10px;
    }
    .name{
      font-size:26px;
    }
    .iconfont {
      display: block;
      position: absolute;
      width: 60px;
      height: 60px;
      color: #fff;
      text-align: center;
      margin: 40px auto 0;
      font-size: 40px;
      line-height: 60px;
      border: 1px solid #fff;
      border-radius: 50%;
      bottom: -100px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
